'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _config = require('../../config');

var _config2 = _interopRequireDefault(_config);

var _components = require('../../components');

var _Resources = require('./Resources.css');

var _Resources2 = _interopRequireDefault(_Resources);

var _container = require('../../helpers/container');

var _container2 = _interopRequireDefault(_container);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Resources = (_dec = (0, _reactCssModules2.default)(_Resources2.default, { allowMultiple: true }), _dec(_class = function (_Component) {
  (0, _inherits3.default)(Resources, _Component);

  function Resources(props) {
    (0, _classCallCheck3.default)(this, Resources);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Resources.__proto__ || (0, _getPrototypeOf2.default)(Resources)).call(this, props));

    _this.renderResourcesContent = function (message, url) {
      return _react2.default.createElement(
        'div',
        { styleName: 'resources' },
        _react2.default.createElement(
          'div',
          { styleName: 'resources-inner' },
          _react2.default.createElement(
            'div',
            { styleName: 'title' },
            'Resources'
          ),
          _react2.default.createElement(
            'div',
            { styleName: 'subtitle' },
            'Fossil free investing resources'
          ),
          _react2.default.createElement(
            'p',
            { styleName: 'answer-lede' },
            _react2.default.createElement(
              'em',
              null,
              'As You Sow is not an investment advisor, nor do we provide financial planning, legal or tax advice. Nothing on this website shall constitute or be construed as an offering of financial instruments, or as investment advice or investment recommendations. ',
              _react2.default.createElement(
                _components.Link,
                { to: _config2.default.routes.legal, title: 'Legal', xstrong: true },
                'See our full disclaimer',
                _react2.default.createElement(_components.LinkIcon, null)
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { styleName: 'answer-title' },
            'Financial consulting firms'
          ),
          _react2.default.createElement(
            'p',
            { styleName: 'answer-lede' },
            'Financial consultants provide financial advice to corporations and money managers, including company HR or finance teams that manage employee retirement plans. The firms below focus on integrating socially responsible investments into their financial advice.'
          ),
          _react2.default.createElement(
            'p',
            null,
            _react2.default.createElement(
              _components.Link,
              { to: 'https://socialk.com/', xstrong: true, title: 'Social K' },
              'Social K'
            ),
            ' \u2014 Social K is a financial consulting firm helping manage retirement plans with environmental, social, and governance considerations. They work alongside company or non-profit organization HR or finance teams to help them to design a retirement plan which is tailor-fit.'
          ),
          _react2.default.createElement(
            'p',
            null,
            _react2.default.createElement(
              _components.Link,
              { to: 'http://www.greenretirement.com/greenretirement.aspx', xstrong: true, title: 'Green Retirement' },
              'Green Retirement'
            ),
            ' \u2014 Green Retirement Plans is a B Corporation specializing in setting up small business 401(k), nonprofit organization 403(b), and individual IRA plans that include sustainable and socially responsible investments.'
          ),
          _react2.default.createElement(
            'p',
            null,
            _react2.default.createElement(
              _components.Link,
              { to: 'https://portal.valuesadvisor.org/ays', xstrong: true, title: 'ValuesAdvisor' },
              'ValuesAdvisor'
            ),
            ' \u2014 ValuesAdvisor is a nonprofit platform that connects you with values-aligned financial advisors recommended by impact investors, helping you secure your financial future while addressing the world\'s most pressing environmental problems. They provide access to their proprietary database to find advisors who align with your sustainable investing goals.'
          ),
          _react2.default.createElement(
            'div',
            { styleName: 'answer-title' },
            'Brokerage services'
          ),
          _react2.default.createElement(
            'p',
            { styleName: 'answer-lede' },
            'If you\u2019ve found mutual funds or ETFs on Fossil Free Funds that fit your investing circumstances, you can use traditional brokerage services to invest in them directly or through an IRA portfolio. You can use traditional financial brokers to invest, or search online to find online brokerage services.'
          ),
          _react2.default.createElement(
            'div',
            { styleName: 'answer-title' },
            'Automated socially responsible investing services'
          ),
          _react2.default.createElement(
            'p',
            { styleName: 'answer-lede' },
            '"Robo-advisors" are a class of financial advisor that provide financial advice or investment management online with moderate to minimal human intervention, helping keep fees low. You can search online to find advisors that offer automated platforms that integrate environmental concerns, and other socially responsible investment issues.'
          ),
          _react2.default.createElement(
            'div',
            { styleName: 'answer-title' },
            'Responsible investing and fossil fuel divestment educational resources'
          ),
          _react2.default.createElement(
            'p',
            { styleName: 'answer-lede' },
            'If you\u2019re looking to get more informed on fossil fuel divestment, fossil free investing, and other socially responsible investment issues, the educational resources below can help.'
          ),
          _react2.default.createElement(
            'p',
            null,
            _react2.default.createElement(
              _components.Link,
              { to: 'https://www.ussif.org/', xstrong: true, title: 'US-SIF' },
              'US-SIF'
            ),
            ' \u2014 US SIF: The Forum for Sustainable and Responsible Investment is a United States-based membership association that advances sustainable, responsible and impact investing across all asset classes. They can also help you find responsible investment managers to move your money fossil free.'
          ),
          _react2.default.createElement(
            'p',
            null,
            _react2.default.createElement(
              _components.Link,
              { to: 'https://www.greenamerica.org/divest-reinvest', xstrong: true, title: 'Green America' },
              'Green America'
            ),
            ' \u2014 Green America is a nonprofit membership organization based in the United States that promotes ethical consumerism. Their \u201CCreating a Fossil Free Portfolio\u201D guide teaches you how to get started investing fossil free.'
          ),
          _react2.default.createElement(
            'p',
            null,
            _react2.default.createElement(
              _components.Link,
              { to: 'https://gofossilfree.org/', xstrong: true, title: 'Go Fossil Free' },
              'Go Fossil Free'
            ),
            ' \u2014 The Go Fossil Free campaign, from ',
            _react2.default.createElement(
              _components.Link,
              { to: 'https://350.org/', xstrong: true, title: '350.org' },
              '350.org'
            ),
            ', is a hub for campaigns working towards a fast and just transition to 100% renewable energy for all.'
          ),
          _react2.default.createElement(
            'div',
            { styleName: 'answer-title' },
            'Partners and research providers'
          ),
          _react2.default.createElement(
            'p',
            { styleName: 'answer-lede' },
            'Financial research providers help Fossil Free Funds identify fossil fuel companies in common mutual funds. The firms listed below all provide expertise and company research to help Fossil Free Funds track fossil fuel investments and keep our data up-to-date.'
          ),
          _react2.default.createElement(
            'p',
            null,
            _react2.default.createElement(
              _components.Link,
              { to: 'https://www.ffisolutions.com', xstrong: true, title: 'FFI Solutions' },
              'FFI Solutions'
            ),
            ' \u2014 FFI Solutions provides research products and investment solutions that reduce environmental risk while managing portfolio risk. They provide the Carbon Underground 200 index used by Fossil Free Funds, identifying the top global 200 publicly-owned coal, oil, and gas reserve owners ranked by the carbon emissions embedded in their reserves.'
          ),
          _react2.default.createElement(
            'p',
            null,
            _react2.default.createElement(
              _components.Link,
              { to: 'https://macroclimate.com/', xstrong: true, title: 'Macroclimate' },
              'Macroclimate'
            ),
            ' \u2014 Macroclimate is a B Corporation and fiduciary advisor that helps you invest in impact investment portfolios. They also provide investment research, including the Macroclimate 50 index used by Fossil Free Funds, identifying the 50 largest public-company owners of coal-fired power plants in Developed Markets plus China and India.'
          ),
          _react2.default.createElement(
            'p',
            null,
            _react2.default.createElement(
              _components.Link,
              { to: 'http://www.corporateknights.com/', xstrong: true, title: 'Corporate Knights' },
              'Corporate Knights'
            ),
            ' \u2014 Corporate Knights is a media, research and financial information products company focused on promoting \u201Cclean capitalism\u201D, where prices fully incorporate social, economic and ecological costs and benefits. They partner with As You Sow to provide the Carbon Clean 200 index used by Fossil Free Funds, identifying the 200 largest publicly listed companies by their total clean energy revenues.'
          ),
          _react2.default.createElement(
            'p',
            null,
            _react2.default.createElement(
              _components.Link,
              { to: 'http://www.morningstar.com/company/sustainability', xstrong: true, title: 'Morningstar' },
              'Morningstar'
            ),
            ' \u2014 Morningstar is an investment research company offering mutual fund, ETF, and stock analysis, ratings, and data, and portfolio tools. In addition to providing the fund and company data that powers Fossil Free Funds, they offer Sustainability Rating for funds evaluating how well the companies in a fund\u2019s portfolio are managing the environmental, social, and governance\u2014or ESG\u2014investing factors relevant to their industries.'
          ),
          _react2.default.createElement(
            'p',
            null,
            _react2.default.createElement(
              _components.Link,
              { to: 'https://yoursri.com/', xstrong: true, title: 'yourSRI.com/CSSP' },
              'yourSRI.com/CSSP'
            ),
            ' \u2014 With its online platform yourSRI.com, CSSP helps asset managers and asset owners worldwide to adequately manage risks related to ESG and Carbon issues. yourSRI.com provides the carbon footprint data for mutual funds that you find on Fossil Free Funds.'
          )
        )
      );
    };

    return _this;
  }

  (0, _createClass3.default)(Resources, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      if (typeof window !== 'undefined') {
        window.scrollTo(0, 0);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var title = 'Resources';
      var description = 'Get your money out of fossil fuels. Find resources for investing fossil free.';
      var url = _config2.default.domain + _config2.default.routes.resources;

      var message = 'Resources for investing fossil free';

      // const bannerImage = 'green'
      // const bannerHeadline = 'Resources'
      // const bannerSubtitle = 'Resources for investing fossil free'

      return _react2.default.createElement(
        'div',
        null,
        _container2.default.helmet(title, description, url),
        this.renderResourcesContent(message, url),
        _react2.default.createElement(_components.GetStartedInput, null),
        _react2.default.createElement(
          'div',
          { styleName: 'resources' },
          _react2.default.createElement(
            'div',
            { styleName: 'resources-inner' },
            _react2.default.createElement(_components.AboutBanner, null)
          )
        )
      );
    }
  }]);
  return Resources;
}(_react.Component)) || _class);
exports.default = Resources;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/Resources/Resources.js
// module id = 1417
// module chunks = 0